import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import CreateTournament from './submodules/create';
import ListTournament from './submodules/list';

const BannerDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.tournament}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].getTournaments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={ListTournament}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.tournament}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.tournament].createTournament]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={CreateTournament}
				exact
			/>

			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default BannerDashboard;
